import { CommonRoutes } from '@xemplo/common-routes';
import { LoginActions, LogoutActions } from '@xemplo/types';

import { ConfirmLogin } from './confirm-login';
import { Login } from './login';
import { Logout } from './logout';
import { SilentRenew } from './silent-renew';

/**
 * The most generic implementation of react-router-dom
 * routes for authentication. This should be the same
 * for vast majority of our next gen applications.
 */
export const AUTH_ROUTING = [
  {
    path: CommonRoutes.Login,
    element: <Login action={LoginActions.Login} />,
  },
  {
    path: CommonRoutes.ConfirmLogin,
    element: <ConfirmLogin />,
  },
  {
    path: CommonRoutes.Logout,
    element: <Logout action={LogoutActions.Logout} />,
  },
  {
    path: CommonRoutes.ConfirmLogout,
    element: <Logout action={LogoutActions.LogoutCallback} />,
  },
  {
    path: CommonRoutes.SilentRenew,
    element: <SilentRenew />,
  },
];
